import * as React from "react";
import generatePDF, { Margin, Resolution } from "react-to-pdf";

import { DoneAllRounded } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { CurrencyFormat } from "./currencyformatter";

export const TransactionReciept = ({ location }) => {
  const {
    mode,
    transaction_type,
    amount,
    accountnumber,
    fullname,
    date,
    uid,
  } = location.state;

  const isCredit = transaction_type === "Credit";

  return (
    <>
      <div
        style={{
          width: "100%",
          marginLeft: "auto",
          boxSizing: "border-box",
          marginRight: "auto",
          display: "block",

          maxWidth: "450px",
        }}
        id="content-id"
      >
        {
          //  <img src={require("../../images/logo.png")} />
        }
        <Card sx={{ backgroundColor: "#f9f9f9" }} variant="outlined">
          <CardContent>
            <Grid
              container
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Grid item xs={12} md={12}>
                <Stack
                  direction="column"
                  spacing={1}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Avatar
                    sx={{ width: 70, height: 70, backgroundColor: "green" }}
                  >
                    <DoneAllRounded sx={{ fontSize: 50 }} />
                  </Avatar>
                  <Typography variant="h6">Transfer Completed</Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} md={12}>
                <List>
                  <ListItem>
                    <ListItemText
                      primary={"Flows"}
                      primaryTypographyProps={{ variant: "h6" }}
                    />
                    <ListItemSecondaryAction>
                      <span
                        style={{
                          padding: "8px 15px",
                          borderRadius: 40,
                          backgroundColor: isCredit ? "green" : "#e65001",
                          color: "white",
                        }}
                      >
                        {transaction_type}
                      </span>
                    </ListItemSecondaryAction>
                  </ListItem>
                  {[
                    { title: "Type", value: `${mode} Transfer` },
                    { title: "To", value: fullname },
                    { title: "Account number", value: accountnumber },
                    {
                      title: "Amount",
                      value: <CurrencyFormat amount={amount} />,
                    },
                    {
                      title: "Reference ID",
                      value: uid,
                    },

                    { title: "Date", value: date },
                  ].map((det, index) => (
                    <ListItem key={index}>
                      <ListItemText
                        primary={det.title}
                        primaryTypographyProps={{ variant: "body2" }}
                      />
                      <ListItemSecondaryAction>
                        <Box>
                          <Typography
                            variant="body1"
                            sx={{
                              textAlign: "right",
                              width: 140,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "right",
                              textTransform: "capitalize",
                            }}
                          >
                            {det.value}
                          </Typography>
                        </Box>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
      <Box mt={5} display={"flex"} justifyContent={"center"}>
        <PdfButton />
      </Box>
    </>
  );
};

const options = {
  // default is `save`
  method: "open",
  // default is Resolution.MEDIUM = 3, which should be enough, higher values
  // increases the image quality but also the size of the PDF, so be careful
  // using values higher than 10 when having multiple pages generated, it
  // might cause the page to crash or hang.
  resolution: Resolution.HIGH,
  page: {
    // margin is in MM, default is Margin.NONE = 0
    margin: Margin.SMALL,
    // default is 'A4'
    format: "A6",
    // default is 'portrait'
    orientation: "portrait",
  },
  canvas: {
    // default is 'image/jpeg' for better size performance
    mimeType: "image/png",
    qualityRatio: 1,
  },
  // Customize any value passed to the jsPDF instance and html2canvas
  // function. You probably will not need this and things can break,
  // so use with caution.
  overrides: {
    // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
    pdf: {
      compress: true,
    },
    // see https://html2canvas.hertzen.com/configuration for more options
    canvas: {
      useCORS: true,
    },
  },
};

const getTargetElement = () => document.getElementById("content-id");

export const PdfButton = () => {
  return (
    <Button
      variant="contained"
      color="success"
      disableElevation
      onClick={() => generatePDF(getTargetElement, options)}
    >
      Share
    </Button>
  );
};
